import {
  IconBuilding,
  IconChartBar,
  IconChartLine,
  IconFileCheck,
  IconMessageStar,
  IconRobot,
  IconUsers,
} from '@tabler/icons-react';

import { createFileRoute } from '@tanstack/react-router';

import { Container, Stack, Tabs, Text, Title } from '@optiro/ui';

import { AIUsage } from '@/modules/Admin/AIUsage';
import { Acceptances } from '@/modules/Admin/Acceptances';
import Accounts from '@/modules/Admin/Accounts/Accounts';
import Companies from '@/modules/Admin/Companies/Companies';
import { Ratings } from '@/modules/Admin/Ratings';
import { Statistics } from '@/modules/Admin/Statistics/Statistics';
import { ProjectFeedbackReportsView } from '@/modules/ProjectFeedbackReports/ProjectFeedbackReportsView';

export const Route = createFileRoute('/admin/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        {/* Header */}
        <div>
          <Title order={1}>Admin Dashboard</Title>
          <Text c="dimmed" size="sm" mt="xs">
            Manage companies, accounts, and view platform analytics
          </Text>
        </div>

        {/* Tabbed Navigation */}
        <Tabs defaultValue="statistics" variant="outline">
          <Tabs.List mb="lg">
            <Tabs.Tab value="statistics" leftSection={<IconChartBar size={16} />}>
              Statistics
            </Tabs.Tab>
            <Tabs.Tab value="companies" leftSection={<IconBuilding size={16} />}>
              Companies
            </Tabs.Tab>
            <Tabs.Tab value="acceptances" leftSection={<IconFileCheck size={16} />}>
              Acceptances
            </Tabs.Tab>
            <Tabs.Tab value="accounts" leftSection={<IconUsers size={16} />}>
              Accounts
            </Tabs.Tab>
            <Tabs.Tab value="ai-usage" leftSection={<IconRobot size={16} />}>
              AI Usage
            </Tabs.Tab>
            <Tabs.Tab value="ratings" leftSection={<IconMessageStar size={16} />}>
              Ratings
            </Tabs.Tab>
            <Tabs.Tab value="feedback-reports" leftSection={<IconChartLine size={16} />}>
              Feedback Reports
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="statistics">
            <Statistics />
          </Tabs.Panel>

          <Tabs.Panel value="companies">
            <Companies />
          </Tabs.Panel>

          <Tabs.Panel value="acceptances">
            <Acceptances />
          </Tabs.Panel>

          <Tabs.Panel value="accounts">
            <Accounts />
          </Tabs.Panel>

          <Tabs.Panel value="ai-usage">
            <AIUsage />
          </Tabs.Panel>

          <Tabs.Panel value="ratings">
            <Ratings />
          </Tabs.Panel>

          <Tabs.Panel value="feedback-reports">
            <ProjectFeedbackReportsView />
          </Tabs.Panel>
        </Tabs>
      </Stack>
    </Container>
  );
}
